import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.index-of.js";
import { nativeEnterUnifiedUrl, nativeSkipToUrl } from '../utils/native';
import isMiniProgram from '../utils/isMiniProgram';
import nativeUrlFormat from '../utils/native-url-format';
export default function (url) {
  var needClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (!url) {
    return;
  }

  var resultUrl = url;
  console.log('是否是小程序环境', isMiniProgram());

  if (isMiniProgram()) {
    var miniProgramUrl = nativeUrlFormat(url);
    var miniprogramTbaPages = ['/pages/home/home', '/pages/cate/cate', '/pages/recovery/recovery', '/pages/user/user'];

    if (/^http/.test(url)) {
      miniProgramUrl = "/pages/web/web?url=".concat(encodeURIComponent(url));
    }

    console.log('我是到了小程序的链接', miniProgramUrl, nativeSkipToUrl);
    var isTabPage = miniprogramTbaPages.find(function (item) {
      if (miniProgramUrl.indexOf(item) !== -1) {
        return item;
      }
    });

    if (isTabPage && window.wx) {
      try {
        window.wx.miniProgram.switchTab({
          url: miniProgramUrl
        });
      } catch (err) {
        console.log(err);
      }

      return;
    }

    nativeSkipToUrl({
      targetUrl: miniProgramUrl,
      needClose: needClose
    });
  } else {
    console.log('我是到了H5的链接', resultUrl, nativeEnterUnifiedUrl);
    nativeEnterUnifiedUrl({
      unifiedUrl: resultUrl
    });
  }
}